import React from "react";

export default function FeatureOne() {
  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-xl-12">
          <div className="features-absolute bg-white shadow rounded overflow-hidden card-group">
            <div className="card border-0 p-4">
              <h5 className="mt-1">Folk Theatre</h5>
              <p className="para-desc text-muted justify">
                Rangabandi, originating from Malavalli a hub of rich folk
                traditions dedicates itself to preserving and promoting folk
                theatre as a vital cultural art form. Through performances and
                initiatives, it bridges traditional storytelling with
                contemporary theatre practices.
              </p>
            </div>

            <div className="card border-0 bg-light p-4">
              <h5 className="mt-1">Children theatre</h5>
              <p className="para-desc text-muted justify">
                Rangabandi envisions nurturing creativity and confidence in
                young minds through its dedicated children's theatre
                initiatives. By engaging children in imaginative storytelling
                and performance, it fosters artistic expression, teamwork, and
                cultural awareness
              </p>
            </div>

            <div className="card border-0 p-4">
              <h5 className="mt-1">Workshops</h5>
              <p className="para-desc text-muted justify">
                Rangabandi conducts inclusive theatre workshops for all age
                groups, fostering artistic growth among both men and women. With
                a special emphasis on women’s theatre, it empowers female
                voices, encouraging their active participation in the cultural
                narrative
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
